import { Api } from "../../../../../../common/openapi";
import type { DropdownFilterItem } from "../../../../../../components/_dropdown-filter";
import { logSeverityToLabel } from "../../../../../../generic/log-severity";

// This is the minimum length that the API require before you can include a query filter
export const MIN_FILTER_LENGTH = 2;

export const SEVERITY_ITEMS: Array<DropdownFilterItem> = [
	Api.LogSeverity.ERROR,
	Api.LogSeverity.WARNING,
	Api.LogSeverity.OTHER,
].map((severity) => ({
	value: severity,
	label: logSeverityToLabel(severity),
}));
